import React from 'react';
import { Wallet, Percent, Calendar } from 'lucide-react';

/**
 * Компонент раздела формы с основными параметрами дохода и ставки НДФЛ
 */
const IncomeSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  const currentYear = new Date().getFullYear();
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Годовой доход */}
      <div>
        <label htmlFor="incomeAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Wallet className="w-4 h-4 mr-2 text-emerald-500" />
          Годовой доход до вычета НДФЛ
        </label>
        <input
          type="text"
          id="incomeAmount"
          name="incomeAmount"
          value={formData.incomeAmount}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.incomeAmount ? 'input-error' : ''}`}
          placeholder="Введите годовой доход"
        />
        {errors.incomeAmount && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.incomeAmount}
          </p>
        )}
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Укажите полную сумму вашего дохода за год до удержания налогов
        </p>
      </div>

      {/* Ставка НДФЛ */}
      <div>
        <label htmlFor="taxRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Percent className="w-4 h-4 mr-2 text-emerald-500" />
          Ставка НДФЛ (%)
        </label>
        <select
          id="taxRate"
          name="taxRate"
          value={formData.taxRate}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.taxRate ? 'input-error' : ''}`}
        >
          <option value="13">13% (стандартная ставка)</option>
          <option value="15">15% (повышенная ставка для доходов свыше 5 млн ₽)</option>
          <option value="30">30% (для нерезидентов РФ)</option>
          <option value="35">35% (для выигрышей, призов и т.д.)</option>
        </select>
        {errors.taxRate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.taxRate}
          </p>
        )}
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Стандартная ставка НДФЛ в России составляет 13%
        </p>
      </div>

      {/* Год начала получения вычета */}
      <div>
        <label htmlFor="startYear" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-emerald-500" />
          Год начала получения вычета
        </label>
        <select
          id="startYear"
          name="startYear"
          value={formData.startYear}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.startYear ? 'input-error' : ''}`}
        >
          <option value={currentYear - 3}>{currentYear - 3}</option>
          <option value={currentYear - 2}>{currentYear - 2}</option>
          <option value={currentYear - 1}>{currentYear - 1}</option>
          <option value={currentYear}>{currentYear} (текущий год)</option>
          <option value={currentYear + 1}>{currentYear + 1} (следующий год)</option>
        </select>
        {errors.startYear && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.startYear}
          </p>
        )}
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Вычет можно получить за текущий год или за предыдущие 3 года
        </p>
      </div>

      {/* Информационный блок */}
      <div className="col-span-full mt-2">
        <div className="p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded text-blue-800 dark:text-blue-200 text-sm">
          <p>
            <strong>Справка:</strong> В России налоговые вычеты позволяют вернуть часть уплаченного НДФЛ. 
            Доход, необлагаемый налогом, не учитывается при расчете вычетов.
          </p>
        </div>
      </div>
    </div>
  );
};

export default IncomeSection;